import { CollapsibleProps } from "@hightouch/formkit";
import { Controller } from "react-hook-form";
import { Card } from "src/components/card";
import { SharedProps } from ".";
import { Collapsible, Form } from "src/formkit/components";

export const FKCollapsible = ({
  label,
  children,
  name,
}: CollapsibleProps & { children: any } & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <Collapsible label={label} value={field.value} onChange={field.onChange}>
        <Card>
          <Form>{children}</Form>
        </Card>
      </Collapsible>
    )}
  />
);
